(function () {
	'use strict';

	var NotificationPopups = (function(){

		var init = function() {
			var notificationPopups = document.querySelectorAll('[data-notification-popup]');
			for (var i = 0; i < notificationPopups.length; i ++) {
				var popup = notificationPopups[i];
				var storageKey = popup.getAttribute('data-notification-popup');
				var isDismissed = window.localStorage.getItem(storageKey);
				if (isDismissed) {
					return;
				}
				popup.style.display = 'block';
				var closePopupLinks = popup.querySelectorAll('[data-notification-popup-dismiss]');
				for (var i = 0; i < closePopupLinks.length; i++) {
					var closePopupLink = closePopupLinks[i];
					closePopupLink.addEventListener('click', function(ev) {
						dismiss(ev, popup, storageKey);
					})
				}
			}
		};

		var dismiss = function(ev, popup, storageKey) {
			ev.stopPropagation();
			window.localStorage.setItem(storageKey, 'dismissed');
			popup.style.display = 'none';
		};
		
		return { init: init };
	}());

	//Leaving this popup code until we move onto AppCues	
	if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
		NotificationPopups.init();
	} else {
		document.addEventListener('DOMContentLoaded', NotificationPopups.init);
	}
}());
